(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    const MOBILE_BREAKPOINT = 749;
  const LINE_COUNT = 4;

  function getTextBlock(root) {
    return root.querySelector('.text-block, rte-formatter.text-block');
  }

  function setExpanded(root, toggle, expanded) {
    root.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.querySelector('.text-read-more__label--more').hidden = expanded;
    toggle.querySelector('.text-read-more__label--less').hidden = !expanded;
  }

  function updateReadMore(root) {
    const textBlock = getTextBlock(root);
    const toggle = root.querySelector('.text-read-more__toggle');

    if (!textBlock || !toggle) return;

    if (window.innerWidth > MOBILE_BREAKPOINT) {
      root.classList.remove('is-expanded', 'has-overflow');
      toggle.hidden = true;
      setExpanded(root, toggle, false);
      return;
    }

    if (root.classList.contains('is-expanded')) {
      root.classList.add('has-overflow');
      toggle.hidden = false;
      return;
    }

    setExpanded(root, toggle, false);

    const lineHeight = parseFloat(getComputedStyle(textBlock).lineHeight) || 24;
    const maxHeight = lineHeight * LINE_COUNT;
    const needsToggle = textBlock.scrollHeight > maxHeight + 1;

    root.classList.toggle('has-overflow', needsToggle);
    toggle.hidden = !needsToggle;
  }

  function initTextReadMore(root) {
    const toggle = root.querySelector('.text-read-more__toggle');
    const textBlock = getTextBlock(root);

    if (!toggle || !textBlock) return;

    toggle.addEventListener('click', () => {
      const expanded = !root.classList.contains('is-expanded');
      setExpanded(root, toggle, expanded);
      updateReadMore(root);
    });

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => updateReadMore(root));
      observer.observe(textBlock);
    }

    window.addEventListener('resize', () => updateReadMore(root));
    updateReadMore(root);
  }

  document.querySelectorAll('[data-text-read-more]').forEach(initTextReadMore);
  } catch(e) { console.error(e); }
})();

})();
